export default () => ({
  trigger: {
    name: 'add_to_cart_page.show_energy_label',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: 'energy_label',
      },
    },
    nonInt: true,
  },
});
